export const GET_FILMS = 'blogs/allFilms/get';
export const GET_CARTELERA_FILMS_BY_CINEMA = 'blogs/carteleraFilmsByCinema/get';
export const GET_FILM_BY_ID = 'blogs/filmById/get';
export const GET_FILM_BY_SLUG = 'blogs/filmBySlug/get';
export const GET_FILM_BY_CINEMA = 'blogs/filmByCinema/get';
export const GET_FILM_BY_FILM = 'blogs/filmByFilm/get';
export const GET_CALIFICATION_BY_FILM = 'blogs/calificationByFilm/get';
